import React, { useContext } from "react";
import "./homegallery.css";
import homegallery1 from "../photos/homegallery1.png";
import homegallery2 from "../photos/homegallery2.png";
import homegallery3 from "../photos/homegallery3.png";
import homegallery4 from "../photos/homegallery4.png";
import homegallery5 from "../photos/homegallery5.png";
import homegallery6 from "../photos/homegallery6.png";
import { NavLink } from "react-router-dom";
import { LanguageContext } from "../settings/LanguageContext";

const galleryphotos = [
  { id: 1, photo: homegallery1, name: "Lori Region", place: "Nature" },
  { id: 2, photo: homegallery2, name: "Noravank Monastery", place: "Culture" },
  { id: 3, photo: homegallery3, name: "Trchkan Waterfall", place: "Nature" },
  { id: 4, photo: homegallery4, name: "Garni Temple", place: "Culture" },
  { id: 5, photo: homegallery5, name: "Tavush Region", place: "Nature" },
  { id: 6, photo: homegallery6, name: "Tatev Monostery", place: "Culture" },
];

const Homegallery = () => {
  const { lang } = useContext(LanguageContext);

  return (
    <div className="main-homegallery">
      <div className="homegallery-container">
        <h4 className="homegallery-title">
          {lang === "EN" ? "Gallery" : "Галерея"}
        </h4>
        <h5 className="explore-homegallery-text">
          {lang === "EN"
            ? "Explore our gallery to discover the beauty of Armenia"
            : "Исследуйте нашу галерею, чтобы открыть красоту Армении"}
        </h5>

        <div className="homegallery-photos">
          {galleryphotos.map((item) => (
            <div key={item.id} className="homegallery-item">
              <img src={item.photo} alt={`homegallery${item.id}`} />
              <div className="overlay">
                <p className="homegallery-tour-phototext">
                  {item.name} <br /> {item.place}
                </p>
              </div>
            </div>
          ))}
        </div>

        <NavLink
          to="/gallery"
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          <div className="viewmore">
            <button className="btn-viewmore">
              {lang === "EN" ? "View More" : "Посмотреть больше"}
            </button>
          </div>
        </NavLink>
      </div>
    </div>
  );
};

export default Homegallery;
